var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A plus icon, to add files.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function PlusIcon(_a) {
    var { size = 'medium' } = _a, rest = __rest(_a, ["size"]);
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, viewBox: "0 0 40 39" }, rest),
        jsx("path", { fill: "currentColor", d: "M20 .975c.552 0 1 .395 1 .882v16.668h17.095c.464 0 .847.376.899.861L39 19.5c0 .538-.405.975-.905.975H21v16.668c0 .452-.386.825-.883.876l-.117.006c-.552 0-1-.395-1-.882V20.475H1.905c-.464 0-.847-.376-.899-.861L1 19.5c0-.538.405-.975.905-.975H19V1.857c0-.452.386-.825.883-.876z" })));
}
//# sourceMappingURL=PlusIcon.js.map